// extracted by mini-css-extract-plugin
module.exports = {"legend":"tableLegend_legend__2LcWF","badge":"tableLegend_badge__N6UwD"};